export const FETCH_AI_WALLETS = "app/AICredits/FETCH_AI_WALLETS";
export const FETCH_AI_WALLETS_SUCCESS =
  "app/AICredits/FETCH_AI_WALLETS_SUCCESS";
export const FETCH_AI_WALLETS_FAILURE =
  "app/AICredits/FETCH_AI_WALLETS_FAILURE";

export const FETCH_AI_LEDGER = "app/AICredits/FETCH_AI_LEDGER";
export const FETCH_AI_LEDGER_SUCCESS = "app/AICredits/FETCH_AI_LEDGER_SUCCESS";
export const FETCH_AI_LEDGER_FAILURE = "app/AICredits/FETCH_AI_LEDGER_FAILURE";
